import React, { SVGProps } from 'react';

const LinkIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M8.33333 10.8333C8.69119 11.3118 9.14779 11.7077 9.67213 11.994C10.1965 12.2803 10.7764 12.4509 11.3722 12.4936C11.9679 12.5363 12.5658 12.4501 13.1245 12.2408C13.6833 12.0314 14.1899 11.7039 14.6083 11.2808L17.1083 8.78083C17.8626 7.99913 18.2798 6.9535 18.2702 5.86913C18.2606 4.78477 17.8251 3.74687 17.0571 2.97887C16.2891 2.21087 15.2512 1.77534 14.1668 1.76574C13.0825 1.75614 12.0368 2.17334 11.2551 2.92749L9.80833 4.36583"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6667 9.16667C11.3088 8.68824 10.8522 8.29234 10.3279 8.00601C9.80353 7.71969 9.22361 7.54909 8.62784 7.50641C8.03206 7.46372 7.43421 7.5499 6.87545 7.75924C6.31669 7.96858 5.81008 8.29606 5.39167 8.71917L2.89167 11.2192C2.13752 12.0009 1.72032 13.0465 1.72992 14.1309C1.73952 15.2152 2.17505 16.2531 2.94305 17.0211C3.71105 17.7891 4.74895 18.2247 5.83332 18.2343C6.91768 18.2439 7.96338 17.8267 8.74508 17.0725L10.1834 15.6342"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LinkIcon;
